import { MoneyIcon } from "assets/icons";
import { GroupIcon } from "assets/icons/Common";
import { BlankAction } from "components/actions";
import {
  InformationSetting,
  MultiLineSetting,
  NumberInputSetting,
  RememberSettings,
  ToggleSetting,
  DropdownSetting, // You can add a SelectSetting to choose between manual and auto.
} from "components/settings";
import { generateUniqueId } from "components/utils";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";
import { LINE_LIMIT_RANDOM_NAME } from "util/widgeTransformData";

import { InteractiveGroupMaker } from "./GroupMaker";
import { OrganiseGroupSetting } from "./organiseGroupSetting";
import { RandomNameWordList } from "./RandomNameWordList";
import { SavedGroupConfigurations } from "./types";

export const InteractiveGroupMakerWidget: WidgetType<SavedGroupConfigurations> = {
  name: "Group Maker",
  component: InteractiveGroupMaker,
  icon: GroupIcon,
  showOnToolbar: true,
  sizing: {
    minWidth: 400,
    minHeight: 200,
    minAspectRatio: 0,
    maxAspectRatio: 0,
  },
  defaultState: {
    id: 0,
    groupConfigName: "Default Group Configuration",
    groups: [
      {
        title: "Group 1",
        students: [],
        point: 0,
      },
    ],
    groupCount: 1,
    groupingMode: "auto",
    showPoints: true,
  },
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 50,
  },
  settings: {
    info: {
      editor: InformationSetting,
      info: {
        info: "Use this widget to create student list and manage groups, assign points, and save configurations.",
      },
    },
    nameList: {
      editor: MultiLineSetting,
      info: {
        lineLimit: LINE_LIMIT_RANDOM_NAME,
        settingName: "Student List",
      },
      defaultValue: "Student1\nStudent2",
    },
    saveWords: {
      editor: RandomNameWordList,
      info: {
        settingName: "nameList",
      },
    },
    groupingMode: {
      editor: DropdownSetting, // A dropdown to select "manual" or "auto"
      info: {
        name: "Grouping Mode",
        options: ["Auto", "Manual"],
        defaultValue: "Auto", // Default to auto grouping
      },
    },
    groupCount: {
      editor: NumberInputSetting,
      info: {
        label: "Number of Groups",
        minValue: 1,
        maxValue: 20,
        wholeNumbers: true,
        value: 1,
        isGroupMaker: true,
      },
    },
    organise: {
      editor: OrganiseGroupSetting,
      info: {},
      defaultValue: {
        id: generateUniqueId(),
        groupConfigName: "Default Group Configuration",
        groups: [],
        groupCount: 1,
        groupingMode: "Auto",
        showPoints: true,
      },
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.groupMaker,
        widgetDisplayName: "Group Maker",
      },
    },
    saveConfiguration: {
      editor: ToggleSetting,
      info: {
        label: "Save Configuration",
      },
      defaultValue: true,
    },
  },
  quickActions: {
    blank: BlankAction,
  },
};
